<template>
    <svg height=10 width=100% version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <linearGradient id="gradientCircle" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:rgb(18,66,163,1);stop-opacity:1" />
          <stop offset="58%" style="stop-color:rgb(0,39,118,1);stop-opacity:1" />
          <stop offset="100%" style="stop-color:rgb(0,35,105,1);stop-opacity:1"/>
        </linearGradient>
      </defs>
      <line x1="10%" x2="90%" y1="50%" y2="50%" stroke="rgba(255, 255, 255, 0.4)" stroke-width="8" stroke-linecap="round"/>
      <line class="progress-line" x1="10%" x2="90%" y1="50%" y2="50%" :stroke-dasharray="normalize + '% 9999'" :stroke="color" stroke-width="8" stroke-linecap="round" />
    </svg>
</template>

<script>
export default {
  name: "Progress_Line",
  props: {
    percent: Number,
    color: String
  },
  computed: {
    normalize() {
      return (this.percent * 1.13).toString();
    }
  }
};
</script>

<style>
.progress-line {
  animation: line-chart-fill 2s cubic-bezier(0.53, 0, 0.58, 0.82) reverse;
  -webkit-animation: line-chart-fill 2s cubic-bezier(0.53, 0, 0.58, 0.82)
    reverse;
  transition: all 2s;
}
@keyframes line-chart-fill {
  to {
    stroke-dasharray: 0;
  }
}
</style>
